// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { Form } from 'mobx-react-form';
import getPluginsConfig from './plugins';

// Declare handler names and args.
export interface Hooks {
  onSuccess?: (form: Form) => any;
  onSubmit?: (form: Form) => any;
  onClear?: (form: Form) => any;
  onReset?: (form: Form) => any;
}

// Declare field names and types.
export interface Field {
  name: string;
  type?: string;
  rules?: string;
  options?: { [key: string]: any };
  value?: any;
  role?: string;
}

// Class to setup a base form.
export default class BaseForm extends Form {
  // Setup fields and hooks which are passed in from props.
  constructor(props: { fields?: any; hooks?: Hooks } = {}) {
    const { fields = [], hooks } = props;

    super({ fields }, { hooks });
  }

  // Setup validation plugin.
  plugins() {
    return getPluginsConfig(); // Setup Declarative Validation Rules (DVR).
  }

  // Setup basic options.
  options() {
    return ({
      autoParseNumbers: true,
      validateOnChange: false,
      validateOnBlur: true,
      validationDebounceWait: 0,
      showErrorsOnReset: false,
    });
  }
}